module.exports = __webpack_public_path__ + "static/media/license_back.cbb9fb58.svg";